const notification = {
  NOTIFICATIONS: 'NOTIFICATIONS'
}
export { notification }
